/* src/app/features/exportacao-agente-financeiro/acomp-metas-distribuicao-limites/acomp-metas-distribuicao-limites.component.scss */
.acomp-metas .titulo {
  font-weight: bold;
}
/*# sourceMappingURL=acomp-metas-distribuicao-limites.component.css.map */
